import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FilterBar from '../components/FilterBar';
import PageGuide from '../components/PageGuide';
import { RegionCropDecisionView } from '../components/DecisionIntelligenceViews';
import '../styles/NewDashboard.css';
import filterParams from '../utils/filterParams';

export default function FieldIntelV2({ filters, setLoading }) {
  const [data, setData] = useState({ cells: [] }),
    [busy, setBusy] = useState(true),
    [error, setError] = useState('');
  useEffect(() => {
    const c = new AbortController();
    setBusy(true);
    setLoading(true);
    setError('');
    axios
      .get(`/api/decision/region-crop?${filterParams(filters)}`, { signal: c.signal })
      .then((r) => setData(r.data || { cells: [] }))
      .catch((e) => {
        if (!axios.isCancel(e)) setError('Field intelligence could not be loaded.');
      })
      .finally(() => {
        setBusy(false);
        setLoading(false);
      });
    return () => c.abort();
  }, [filters, setLoading]);
  return (
    <div className="v2-page">
      <div className="module-header">
        <div className="module-kicker">MARKET INTELLIGENCE</div>
        <h2>Field Intelligence</h2>
        <p>
          Where farmer and retailer needs are developing, which crops are affected, and the conversations
          behind them.
        </p>
      </div>
      <FilterBar />
      <PageGuide
        purpose="Find the location and crop combinations that deserve attention, then verify them against the original conversations."
        steps={[
          'Use the colour status to find what needs attention.',
          'Select a location and crop combination.',
          'Read the evidence and related topics before deciding what to do.',
        ]}
        metrics={[
          {
            name: 'Urgency score',
            definition:
              'A 0–100 prioritisation based on issue evidence, conversation volume and breadth of contributors. It is not severity.',
          },
          {
            name: 'Conversations',
            definition: 'Distinct field conversations containing the selected crop or issue.',
          },
          {
            name: 'Contributors',
            definition: 'Distinct field team members whose conversations support the finding.',
          },
          {
            name: 'Current / emerging / declining',
            definition: 'Whether mentions are stable, increasing or decreasing over the available timeline.',
          },
        ]}
      />
      {error && <div className="decision-empty">{error}</div>}
      <RegionCropDecisionView data={data} filters={filters} loading={busy} />
    </div>
  );
}
